<template>
	<div>
        <el-form ref="form" :model="selectedInsurances" label-position="left" label-width="140px">

            <el-form-item label="Comprehensive">
                <el-select multiple class="w-100" :loading="comprehensiveInsuranceLoading" v-model="selectedInsurances.comprehensiveInsurance" placeholder="Comprehensive Insurance">
                    <el-option
                        v-for="item in comprehensiveInsurances"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="CCI / BCI">
                <el-select multiple class="w-100" :loading="ccibciLoading" v-model="selectedInsurances.ccibci" placeholder="CCI / BCI">
                    <el-option
                        v-for="item in ccibci"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Warranty">
                <el-select multiple class="w-100" :loading="warrantyLoading" v-model="selectedInsurances.warranty" placeholder="Warranty">
                    <el-option
                        v-for="item in warranty"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="GAP">
                <el-select multiple class="w-100" :loading="gapLoading" v-model="selectedInsurances.gap" placeholder="GAP">
                    <el-option
                        v-for="item in gap"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

        </el-form>
	</div>
</template>

<script>
	import InsuranceTierData from "@ambition/components/single-option/data/InsuranceTierData"
    import { getRootState } from "@ambition/components/single-option/data/State";
	import { mapGetters } from "vuex"

	export default {
		name: "AssetInsurances",
		props: {
            
		},
		components: {
            
		},
		watch: {
            
		},
		data() {
			return {
                selectedInsurances: {},
				insurances: [],
				transformedInsurances: [],
                comprehensiveInsuranceLoading: true,
                ccibciLoading: true,
                warrantyLoading: true,
                gapLoading: true,
			}
		},
		async mounted() {
			try {
				this.getInsurances()
			} catch (err) {
				console.error(err)
			}
			const rootState = await getRootState(this.initAppData.aai)
			if (rootState) this.$store.dispatch("loanOptions/saveCurrentState", rootState)
		},
		activated() {},
		computed: {
			...mapGetters({
				emailBuilder: "builderEmail/getEmail",
				initAppData: "initAppData",
                currentState: "loanOptions/getCurrentState"
			}),
			comprehensiveInsurances() {
                if (_.isEmpty(this.transformedInsurances)) return []
				let comprehensiveInsurances = this.transformedInsurances.find((insurances) => insurances.name === "Comprehensive")
                this.comprehensiveInsuranceLoading = false
                let comprehensives = []

                if (_.get(comprehensiveInsurances, 'options')) {
                    comprehensives = comprehensiveInsurances.options.map(item => {
                        if (item.insurance) {
                            if (!item.name) {
                                item.name = item.label;
                            }
                            item.label = item.insurance.name + ' - ' + item.name;
                            return item;
                        }
                    });
                }
				return comprehensives
			},
            ccibci() {
                if (_.isEmpty(this.transformedInsurances)) return []
				let ccibci = this.transformedInsurances.find((insurances) => insurances.name === "CCI/BCI")
                this.ccibciLoading = false
				return _.get(ccibci, 'options', [])
			},
            warranty() {
                if (_.isEmpty(this.transformedInsurances)) return []
				let warranty = this.transformedInsurances.find((insurances) => insurances.name === "Warranty")
                this.warrantyLoading = false
				return _.get(warranty, 'options', [])
			},
            gap() {
                if (_.isEmpty(this.transformedInsurances)) return []
				let gap = this.transformedInsurances.find((insurances) => insurances.name === "GAP")
                this.gapLoading = false
				return _.get(gap, 'options', [])
			},
		},
		methods: {
			async getInsurances() {
				let adminHeaders = {
					params: {
						asset_type_id: this.initAppData.asset_type_id,
					},
					headers: { Authorization: "Bearer " + this.$store.getters.adminToken },
				}

				let adminUrl = process.env.MIX_APP_URL

				return new Promise(async (resolve, reject) => {
					const rootState = await getRootState(this.initAppData.aai)
					if (rootState) this.$store.dispatch("loanOptions/saveCurrentState", rootState)

					axios
						.get(adminUrl + "/api/insurance-tiers", adminHeaders)
						.then((res) => {
							// get the unique ids in to an array
							// update to group based on title (insurance tier type)

							let titles = Array.from(new Set(res.data.map((a) => a.title)))
							// iterate through unique ids
							this.insurances = []

							for (let title of titles) {
								let insuranceClass = res.data.filter((insurance) => insurance.title == title)
								this.insurances.push(insuranceClass)
							}

							let tierData = new InsuranceTierData(this.insurances, this.currentState)

							this.transformedInsurances = tierData.getProductsPerTier()
							// this.getFirstOption()
							resolve()
						})
						.catch((err) => {
							reject(err)
						})
				})
			},
		},
        watch: {
            selectedInsurances: {
                handler(selectedInsurances) {
                    this.$emit('input', selectedInsurances)
                },
                deep: true,
                immediate: true,
            }
        }
	}
</script>

<style lang="scss" scoped>
    .el-form-item__label {
        text-align: right !important;
    }
</style>